import type { RouteObject } from 'react-router-dom';
import ErrorPage from '~/shared/components/ErrorPage';
import LoginPage from '~/modules/auth/LoginPage';
import Profile from '~/modules/profile/Profile';
import Home from '~/modules/home/Home';
import NotFound from '~/shared/components/NotFound';
import Layout from './shared/components/Layout';
import { ProtectedRoute } from '~/components/ProtectedRoute';
import { MatterListPage, MatterDetailPage } from '~/modules/matters';
import ProfilePage from '~/modules/profile/ProfilePage';
import ViewUserProfilePage from '~/modules/profile/ViewUserProfilePage';
import ExpertProfilePage from '~/modules/connect/ExpertProfilePage';
import AttorneyProfilePage from '~/modules/connect/AttorneyProfilePage';
import SetupPayoutsPage from '~/modules/connect/SetupPayoutsPage';
import ExpertStripeOnboardingReturnPage from '~/modules/connect/ExpertStripeOnboardingReturnPage';
import ExpertStripeOnboardingRefreshPage from '~/modules/connect/ExpertStripeOnboardingRefreshPage';
import RetainerFundingSuccessPage from '~/modules/matters/RetainerFundingSuccessPage';
import RetainerFundingCancelPage from '~/modules/matters/RetainerFundingCancelPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'matters',
        element: <MatterListPage />,
      },
      {
        path: 'matters/:matterId',
        element: <MatterDetailPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'profile/:userId',
        element: <ViewUserProfilePage />,
      },
      {
        path: 'experts/:expertId',
        element: <ExpertProfilePage />,
      },
      {
        path: 'attorneys/:attorneyId',
        element: <AttorneyProfilePage />,
      },
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'user/:userId',
        element: <Profile />,
      },
      {
        path: 'connect/setup-payouts',
        element: <SetupPayoutsPage />,
      },
      {
        path: 'expert/stripe/onboarding/return',
        element: <ExpertStripeOnboardingReturnPage />,
      },
      {
        path: 'expert/stripe/onboarding/refresh',
        element: <ExpertStripeOnboardingRefreshPage />,
      },
      {
        path: 'retainer/funding/success',
        element: <RetainerFundingSuccessPage />,
      },
      {
        path: 'retainer/funding/cancel',
        element: <RetainerFundingCancelPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export { routes };
